import { defaultInitConfig } from './const';
import { createKeycloak, initKeycloak } from './keycloak';
import { isPromise, isFunction, isNil, isString } from './utils';
import { loadJsonConfig } from './config';
export const vueKeycloak = {
    async install(app, options) {
        if (isNil(options)) {
            throw new Error('The Keycloak.KeycloakConfig are requried');
        }
        let keycloakPluginConfig;
        if (isString(options)) {
            keycloakPluginConfig = await loadJsonConfig(options);
        }
        else if (isPromise(options) || isFunction(options)) {
            keycloakPluginConfig = await options();
        }
        else {
            keycloakPluginConfig = options;
        }
        const keycloakConfig = keycloakPluginConfig.config;
        const keycloakInitOptions = !isNil(keycloakPluginConfig.initOptions)
            ? Object.assign(Object.assign({}, defaultInitConfig), keycloakPluginConfig.initOptions) : defaultInitConfig;
        const _keycloak = createKeycloak(keycloakConfig);
        app.config.globalProperties.$keycloak = _keycloak;
        await initKeycloak(keycloakInitOptions);
    },
};
//# sourceMappingURL=plugin.js.map